// Übersetzt strukturierte Backend-Fehlercodes in verständliche, nicht-
// technische UI-Meldungen. Keine SQL-/Security-Details, keine PII an den
// Nutzer. Unbekannte Fehler => generische Meldung.
const MAP: Record<string, string> = {
  AUTH_REQUIRED: "Bitte erneut anmelden.",
  UNAUTHORIZED: "Für diese Aktion fehlt die Berechtigung.",
  PROFILE_INACTIVE: "Dieses Konto ist derzeit nicht aktiv.",
  NOT_A_MERCHANT: "Dieses Konto ist kein Händlerkonto.",
  NOT_A_MEMBER: "Keine Berechtigung für diesen Händler.",
  ORDER_NOT_FOUND: "Die Bestellung wurde nicht gefunden.",
  INVALID_STATUS_TRANSITION: "Diese Bestellung wurde inzwischen geändert. Ansicht wird aktualisiert.",
  ORDER_ALREADY_FINAL: "Diese Bestellung ist bereits abgeschlossen.",
  INVALID_PREP_TIME: "Bitte eine gültige Zubereitungszeit wählen.",
  INVALID_REJECT_REASON: "Bitte einen gültigen Ablehnungsgrund wählen.",
  CAPACITY_REACHED: "Die Kapazität für diesen Zeitraum ist erreicht.",
  INVALID_TERMINAL_ID: "Terminal-Kennung ungültig. Bitte Seite neu laden.",
  INVALID_PERMISSION_STATUS: "Ungültiger Benachrichtigungsstatus.",
  INTERNAL_ERROR: "Aktion konnte nicht abgeschlossen werden. Bitte erneut versuchen.",
  SUPABASE_NOT_CONFIGURED: "Verbindung ist nicht konfiguriert.",
};

/** Extrahiert einen kompakten Fehlercode aus einer Supabase-/RPC-Antwort. */
export function extractErrorCode(err: unknown): string {
  if (!err) return "UNKNOWN";
  const anyErr = err as { message?: string; error_description?: string; code?: string };
  const raw = (anyErr.message || anyErr.error_description || anyErr.code || String(err)).trim();
  // PostgreSQL RAISE liefert oft nur den Code als message.
  const token = raw.split(/[\s:]/)[0]?.toUpperCase() ?? "";
  if (MAP[token]) return token;
  if (MAP[raw.toUpperCase()]) return raw.toUpperCase();
  return raw || "UNKNOWN";
}

export function humanizeError(err: unknown): string {
  const code = extractErrorCode(err);
  return MAP[code] ?? "Aktion konnte nicht abgeschlossen werden. Bitte erneut versuchen.";
}
